/**
 * QR Code Redirect Page
 * Redirects /r/:shortCode to the backend API for processing
 */
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../utils/constants';

const RedirectPage = () => {
  const { shortCode } = useParams<{ shortCode: string }>();

  useEffect(() => {
    if (shortCode) {
      // Redirect to backend API
      window.location.href = `${API_BASE_URL}/r/${shortCode}`;
    }
  }, [shortCode]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
};

export default RedirectPage;
